import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 12h-18","key":"svg-0"}],["path",{"d":"M6 9l-3 3l3 3","key":"svg-1"}],["path",{"d":"M21 9v6","key":"svg-2"}]]

/**
 * IconArrowLeftBar
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctbGVmdC1iYXIiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTIxIDEyaC0xOCIgLz4KICA8cGF0aCBkPSJNNiA5bC0zIDNsMyAzIiAvPgogIDxwYXRoIGQ9Ik0yMSA5djYiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/arrow-left-bar
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowLeftBar = createReactComponent('outline', 'arrow-left-bar', 'ArrowLeftBar', __iconNode);

export default IconArrowLeftBar;